import {Company} from "../interfaces/company.interface";

/**
 * Updates the ICP score of the given company.
 *
 * @param company - The company object to update.
 * @param newIcpScore - The new ICP score to set.
 * @returns A new company object with the updated ICP score.
 */
export function updateCompanyIcpScore(
  company: Company,
  newIcpScore: number,
  searchCompanyIcpDetail: any
): Company {
  if (!company) {
    console.error('Company object is not defined.');
    return null;
  }

  return {
    ...company,
    icp_score: newIcpScore,
    search_company_icp_detail: searchCompanyIcpDetail
  };
}
